export function storeDefaultValue<T>() {
  return undefined as T | undefined;
}